export interface MetricsSnapshot {
  id: string
  tenantId: string
  ownerId: string
  tenantName: string
  ownerName: string
  ownerEmail: string
  lifecycleState: string
  dateRangeStart: string | null
  dateRangeEnd: string | null
  runningCount: number
  pendingCount: number
  succeededCount: number
  failedCount: number
  cancelledCount: number
  throttledCount: number
  rejectedCount: number
  totalCount: number
  aggregatedUtc: string | null
}

export interface MetricsSnapshotResponse {
  snapshots: MetricsSnapshot[]
  count: number
  nextKey?: string
  query: {
    type: string
    startDate: string | null
    endDate: string | null
    tenantOnly: boolean
    limit: number | null
  }
}

export interface AggregatedCounts {
  runningCount: number
  pendingCount: number
  succeededCount: number
  failedCount: number
  cancelledCount: number
  throttledCount: number
  rejectedCount: number
  totalCount: number
}

export interface MetricsQueryParams {
  startDate?: string
  endDate?: string
  days?: number
  limit?: number
  startKey?: string
  tenantOnly?: boolean
  lifecycleState?: string
}

// --- Lifecycle State Types & Utilities ---

export type LifecycleState = 'all' | 'active' | 'archived' | 'deleted'

export const LIFECYCLE_STATE_OPTIONS: { label: string; value: LifecycleState }[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Archived', value: 'archived' },
  { label: 'Deleted', value: 'deleted' },
]

/**
 * Filter MetricsSnapshot records by lifecycle state.
 *
 * When selectedState is "all", returns only combined records (lifecycleState === "all")
 * to prevent double-counting. For any other state, returns only matching records.
 */
export function filterByLifecycleState(
  snapshots: MetricsSnapshot[],
  selectedState: LifecycleState,
): MetricsSnapshot[] {
  if (selectedState === 'all') {
    return snapshots.filter((s) => s.lifecycleState === 'all' || !s.lifecycleState)
  }
  return snapshots.filter((s) => s.lifecycleState === selectedState)
}
